<template>

    <router-link
        v-if="routeObject"
        :to="routeObject" class="ui-link" :class="{ disabled }" ref="aRef"
        @click="onClick" :data-action="action">

        <div class="link-icon" v-if="iconVisible">
            <i :class="icon">
                <slot name="icon"></slot>
                <ui-icon v-if="uiIcon" :icon="uiIcon"/>
            </i>
        </div>

        <slot></slot>

    </router-link>

    <a v-else :href="href || '#'" ref="aRef"
       class="ui-link" :class="{ disabled }"
       @click="onClick" :data-action="action">

        <div class="link-icon" v-if="iconVisible">
            <i :class="icon">
                <slot name="icon"></slot>
                <ui-icon v-if="uiIcon" :icon="uiIcon"/>
            </i>
        </div>

        <slot></slot>
    </a>

</template>

<script lang="ts">

import { Component, Prop, Ref, Vue } from 'vue-facing-decorator';

import type { ComponentProps } from '@wittignl/js-core';
import { createComponentMixin } from '@wittignl/js-core';

import Icon from '../ui/Icon.vue';

@Component({
    name: 'ui-link',
    components: {
        'ui-icon': Icon
    },
    emits: ['click']
})
export default class Link extends Vue {

    @Prop({ type: String })
    icon: string;

    @Prop({ type: String })
    uiIcon: string;

    @Prop({ type: String })
    route: string;

    @Prop({ type: Object })
    to: any;

    @Prop({ type: String })
    href: string;

    @Prop({ type: String })
    action: string;

    @Prop({ type: [Boolean, Number] })
    disabled: boolean | number;

    @Prop({ type: [Boolean, Number] })
    hideIcon: boolean | number;

    @Ref
    aRef: any;

    getElement(): HTMLElement {

        return this.aRef;
    }

    get routeObject() {

        if(this.to){

            return this.to;
        }
        else if(this.route){

            return { name: this.route };
        }

        return null;
    }

    onClick(e) {

        if(this.disabled){

            e.preventDefault();
            return;
        }

        const $a = this.aRef.$el || this.aRef;

        $a.blur();

        if(!this.routeObject && !this.href){
            e.preventDefault();
        }

        this.$emit('click', e);
    }

    get iconVisible() {

        return (this.icon || this.uiIcon || this.$slots.icon) && !this.hideIcon;
    }
}

export type LinkComp = InstanceType<typeof Link>
export type LinkProps = ComponentProps<LinkComp>
export const linkCompMixin = createComponentMixin(Link)

</script>
<style src="../../../scss/component/button/Link.scss" lang="scss"></style>